import { Widget, WIDGET_MATRIX } from "@gaming/srvg-classes-core";


export class MatrixWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {

        options = options || {};
        options.selector = options.selector || '#matrixWidget';
        super( options );

        this.name = 'widgetmatrix';
        this.widgetName = options.widgetName || WIDGET_MATRIX;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addMatrixWidget();
        super.handleDomInstantiated();
    }

    /**
     * add matrix widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addMatrixWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addMatrixWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addMatrixWidget(element);
    }



}